export default __webpack_public_path__ + "static/4-97e44e4fac999969f720830e3b300cc2.jpeg";